// src/features/bookings/components/BookingForm/cards/ConditionalDetailsCard.jsx
import React from 'react';
import styles from '../../../../../components/Form.module.css';

// ── Graduation ───────────────────────────────────────────────
const GraduationFields = ({ details, handlers, offerHandlers }) => (
  <fieldset className={styles.fieldset}>
    <legend className={styles.legend}>تفاصيل حجز التخرج</legend>

    <div className={styles.inputGrid}>
      <div className={styles.inputGroup}>
        <label className={styles.formLabel}>الكلية</label>
        <input name="college" value={details.college || ''} onChange={handlers.graduation} />
      </div>
      <div className={styles.inputGroup}>
        <label className={styles.formLabel}>القسم</label>
        <input name="department" value={details.department || ''} onChange={handlers.graduation} />
      </div>
      <div className={styles.inputGroup}>
        <label className={styles.formLabel}>اسم الممثل</label>
        <input name="representative_name" value={details.representative_name || ''} onChange={handlers.graduation} />
      </div>
      <div className={styles.inputGroup}>
        <label className={styles.formLabel}>رقم الموبايل</label>
        <input name="representative_phone" value={details.representative_phone || ''} onChange={handlers.graduation} />
      </div>
      <div className={styles.inputGroup}>
        <label className={styles.formLabel}>عدد الصور الإضافية</label>
        <input type="number" name="extra_photos_count" value={details.extra_photos_count || ''} onChange={handlers.graduation} />
      </div>
      <div className={styles.inputGroup}>
        <label className={styles.formLabel}>سعر الصورة الإضافية</label>
        <input type="number" step="any" name="extra_photo_price" value={details.extra_photo_price || ''} onChange={handlers.graduation} />
      </div>
      <div className={styles.inputGroup}>
        <label className={styles.formLabel}>إيرادات أخرى</label>
        <input type="number" step="any" name="other_revenues" value={details.other_revenues || ''} onChange={handlers.graduation} />
      </div>
      <div className={styles.inputGroup}>
        <label className={styles.formLabel}>إضافات أخرى</label>
        <input type="number" step="any" name="additional_revenues" value={details.additional_revenues || ''} onChange={handlers.graduation} />
      </div>
    </div>

    <h4 style={{ marginTop: '20px', borderTop: '1px solid #eee', paddingTop: '15px' }}>
      إدارة العروض / الباقات
    </h4>

    {details.offers.map((offer, index) => (
      <div key={index} style={{ border: '1px dashed #ccc', padding: '15px', marginBottom: '15px', borderRadius: '8px', position: 'relative' }}>
        <div className={styles.inputGrid}>
          <div className={styles.inputGroup}>
            <label className={styles.formLabel}>اسم العرض</label>
            <input name="name" value={offer.name || ''} onChange={(e) => offerHandlers.handleOfferChange(index, e)} />
          </div>
          <div className={styles.inputGroup}>
            <label className={styles.formLabel}>عدد الطلاب</label>
            <input type="number" name="num_students" value={offer.num_students || ''} onChange={(e) => offerHandlers.handleOfferChange(index, e)} required />
          </div>
          <div className={styles.inputGroup}>
            <label className={styles.formLabel}>سعر العرض للطالب</label>
            <input type="number" step="any" name="offer_price" value={offer.offer_price || ''} onChange={(e) => offerHandlers.handleOfferChange(index, e)} required />
          </div>
          <div className={styles.inputGroup}>
            <label className={styles.formLabel}>تكلفة الطبعة للطالب</label>
            <input type="number" step="any" name="printing_cost" value={offer.printing_cost || ''} onChange={(e) => offerHandlers.handleOfferChange(index, e)} required />
          </div>
        </div>
        {details.offers.length > 1 && (
          <button
            type="button"
            onClick={() => offerHandlers.removeOffer(index)}
            style={{ position: 'absolute', top: '-10px', left: '-10px', background: 'var(--error-color)', color: 'white', border: 'none', borderRadius: '50%', width: '25px', height: '25px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            &times;
          </button>
        )}
      </div>
    ))}

    <button
      type="button"
      onClick={offerHandlers.addOffer}
      style={{ background: 'var(--info-color)', color: 'white', padding: '8px 15px', border: 'none', borderRadius: 'var(--radius-sm)', cursor: 'pointer' }}
    >
      + إضافة عرض آخر
    </button>
  </fieldset>
);

// ── Wedding ──────────────────────────────────────────────────
const WeddingFields = ({ details, handleChange }) => (
  <fieldset className={styles.fieldset}>
    <legend className={styles.legend}>تفاصيل حجز العرس</legend>
    <div className={styles.inputGrid}>
      <div className={styles.inputGroup}>
        <label className={styles.formLabel}>اسم العريس</label>
        <input name="groom_name" value={details.groom_name || ''} onChange={handleChange} />
      </div>
      <div className={styles.inputGroup}>
        <label className={styles.formLabel}>اسم العروس</label>
        <input name="bride_name" value={details.bride_name || ''} onChange={handleChange} />
      </div>
    </div>
    <div className={styles.inputGroup} style={{ marginTop: '15px' }}>
      <label className={styles.formLabel}>تفاصيل الباقة</label>
      <textarea name="package_details" value={details.package_details || ''} onChange={handleChange} rows="3" />
    </div>
    <div className={styles.inputGroup} style={{ marginTop: '15px' }}>
      <label className={styles.formLabel}>خطة وسيناريو الحفل</label>
      <textarea name="event_plan" value={details.event_plan || ''} onChange={handleChange} rows="3" />
    </div>
  </fieldset>
);

// ── Kids ─────────────────────────────────────────────────────
const KidsFields = ({ details, handleChange }) => (
  <fieldset className={styles.fieldset}>
    <legend className={styles.legend}>تفاصيل حجز الأطفال</legend>
    <div className={styles.inputGrid}>
      <div className={styles.inputGroup}>
        <label className={styles.formLabel}>اسم الطفل</label>
        <input name="child_name" value={details.child_name || ''} onChange={handleChange} />
      </div>
      <div className={styles.inputGroup}>
        <label className={styles.formLabel}>عمر الطفل</label>
        <input type="text" name="child_age" value={details.child_age || ''} onChange={handleChange} />
      </div>
      <div className={styles.inputGroup}>
        <label className={styles.formLabel}>جنس الطفل</label>
        <select name="child_gender" value={details.child_gender || 'boy'} onChange={handleChange}>
          <option value="boy">ولد</option>
          <option value="girl">بنت</option>
        </select>
      </div>
      <div className={styles.inputGroup}>
        <label className={styles.formLabel}>ثيم الجلسة</label>
        <input name="session_theme" value={details.session_theme || ''} onChange={handleChange} />
      </div>
    </div>
  </fieldset>
);

// ── Event ────────────────────────────────────────────────────
const EventFields = ({ details, handleChange }) => (
  <fieldset className={styles.fieldset}>
    <legend className={styles.legend}>تفاصيل المناسبة</legend>
    <div className={styles.inputGrid}>
      <div className={styles.inputGroup}>
        <label className={styles.formLabel}>اسم المناسبة</label>
        <input name="event_name" value={details.event_name || ''} onChange={handleChange} />
      </div>
      <div className={styles.inputGroup}>
        <label className={styles.formLabel}>عدد الحضور المتوقع</label>
        <input type="number" name="expected_attendees" value={details.expected_attendees || ''} onChange={handleChange} />
      </div>
    </div>
    <div className={styles.inputGroup} style={{ marginTop: '15px' }}>
      <label className={styles.formLabel}>جدول الفعالية</label>
      <textarea name="event_schedule" value={details.event_schedule || ''} onChange={handleChange} rows="3" />
    </div>
  </fieldset>
);

// ── الرئيسي ──────────────────────────────────────────────────
function ConditionalDetailsCard({ bookingType, details, handlers, offerHandlers }) {
  switch (bookingType) {
    case 'graduation':
      return <GraduationFields details={details.graduation} handlers={handlers} offerHandlers={offerHandlers} />;
    case 'wedding':
      return <WeddingFields details={details.wedding} handleChange={handlers.wedding} />;
    case 'kids':
      return <KidsFields details={details.kids} handleChange={handlers.kids} />;
    case 'event':
      return <EventFields details={details.event} handleChange={handlers.event} />;
    default:
      return null;
  }
}

export default ConditionalDetailsCard;